import { checkState } from '../../../../utils/utils'
import { reCalculateFerme, reCalculateQuery } from '../services/calculApi'

export const reCalculate = (id, onSuccess, onFailure) => (id ? reCalculateQuery(id) : reCalculateFerme())
	.then(taskInProgress => checkState(taskInProgress.id, onSuccess, onFailure))
	.catch(onFailure)